export default __webpack_public_path__ + "static/media/add_product-stap_06.ab84ebb8.png";